<template>
    <q-select
            :model-value="modelValue"
            label="Client"
            :options="clients"
            :option-label="optionLabel"
            option-value="id"
            :map-options="!object"
            :emit-value="!object"
            :loading="isLoading"
            input-debounce="1000"
            use-input
            clearable
            clear-icon="fa fa-times"
            v-bind="$attrs"
            @update:modelValue="$emit('update:modelValue', $event)"
            @filter="filter">
        <template v-slot:prepend>
            <q-icon name="fa fa-search"/>
        </template>
    </q-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import { Client, QueryResult } from '@/type';
import repository from './client-repository';
import { name as nameFilter } from './client-filter';

interface Data {
  task: Promise<QueryResult>|null,
  clients: Client[],
  keyword: string,
}

export default defineComponent({
  emits: ['update:modelValue'],
  mixins: [HasTaskMixin],
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    modelValue: [Number, Object as () => Client],
    object: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      clients: [],
      keyword: '',
    };
  },
  watch: {
    keyword: 'load',
  },
  methods: {
    optionLabel(client: Client) {
      return nameFilter(client);
    },
    filter(inputValue: string, done: Function) {
      if (inputValue) {
        this.keyword = inputValue;
      }
      done();
    },
    load() {
      const filters = { keyword: this.keyword };
      this.task = repository.findAll(this.accountId, filters);
      if (this.task) {
        this.task.then((result: QueryResult) => {
          this.clients = (result.items as Client[]);
        });
      }
    },
  },
  created() {
    this.load();
  },
});
</script>
